interface SignalLostOverlayProps {
  /** Short uppercase chip label. */
  label?: string
  /** Longer sub-label: after a divider, or under the label on narrow widths. */
  detail?: string
}

export function SignalLostOverlay({
  label = 'No temporal signal',
  detail = 'Add time-stamped data to the graph — or clear the active filter — to resume playback.',
}: SignalLostOverlayProps) {
  return (
    // Phone: stay below the floating buttons and the sidebar overlay (z-30),
    // otherwise the sidebar — collapsed by default there — can't be opened.
    <div className="absolute inset-0 z-20 flex items-center justify-center md:z-40">
      <div
        className="absolute inset-0 backdrop-blur-[3px] bg-neutral-950/55 dark:bg-neutral-950/70"
        style={{
          maskImage: 'linear-gradient(to bottom, transparent 0%, black 18%, black 100%)',
          WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 18%, black 100%)',
        }}
      />

      <div
        className="absolute inset-0 opacity-50 pointer-events-none"
        style={{
          backgroundImage:
            'repeating-linear-gradient(0deg, rgba(34,211,238,0.06) 0 1px, transparent 1px 3px)',
        }}
      />

      <div className="absolute top-10 left-3 w-3 h-3 border-t border-l border-amber-400/50 pointer-events-none" />
      <div className="absolute top-10 right-3 w-3 h-3 border-t border-r border-amber-400/50 pointer-events-none" />
      <div className="absolute bottom-2 left-3 w-3 h-3 border-b border-l border-amber-400/50 pointer-events-none" />
      <div className="absolute bottom-2 right-3 w-3 h-3 border-b border-r border-amber-400/50 pointer-events-none" />

      <div className="relative z-10 flex items-center gap-3 px-4 py-2 rounded-sm bg-neutral-950/80 border border-amber-400/35 shadow-[0_0_28px_rgba(251,191,36,0.08)] pointer-events-none max-sm:mx-4 max-sm:items-start">
        <div className="relative w-3 h-3 shrink-0 max-sm:mt-0.5">
          <span className="absolute inset-0 rounded-full bg-amber-400/25 animate-ping" />
          <span className="absolute inset-[3px] rounded-full bg-amber-400 shadow-[0_0_10px_rgba(251,191,36,0.9)]" />
        </div>

        <div className="flex flex-col items-start gap-1 sm:flex-row sm:items-center sm:gap-3">
          <span className="font-mono text-[11px] font-semibold tracking-[0.25em] uppercase text-amber-300">
            {label}
          </span>
          {detail ? (
            <>
              <span className="hidden sm:inline-block w-px h-3.5 bg-amber-400/30" />
              <span className="inline-block font-mono text-[11px] text-cyan-100/75 tracking-[0.02em]">
                {detail}
              </span>
            </>
          ) : null}
        </div>
      </div>
    </div>
  )
}
